import { render, staticRenderFns } from "./ForumsCategories.vue?vue&type=template&id=45e3a764&scoped=true&"
import script from "./ForumsCategories.vue?vue&type=script&lang=js&"
export * from "./ForumsCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e3a764",
  null
  
)

export default component.exports